/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 506
// module chunks = 0